export enum ProductWeightUnit {
    pound = 'lb',
    gram = 'g',
    kilogram = 'kg',
    ounce = 'oz',
}
